import Model from "../Model";
import tw from "tailwind-styled-components";
import { SideCancelBtn, SubmitBtn } from "../Styles/InputStyles";

const DeleteBank = ({
    setIsDeleteBank,
    selectedData,
    deleteBankLoading,
    deleteBankMutate,
    handleClose
}) => {
    const handleDeleteSubmit = () => {
        deleteBankMutate({
            bankAccountId: selectedData?.id,
        });
    };
    return (
        <Model
            width="w-full max-w-md"
            setOpenModel={setIsDeleteBank}
            title="Confirm Deletion"
        >
            <WarningText>
                Are you sure you want to delete this bank account?
            </WarningText>

            <div className="w-full flex justify-between space-x-6 my-4">
                <SideCancelBtn
                    type="button"
                    onClick={handleClose}
                >
                    Cancel
                </SideCancelBtn>
                <SubmitBtn
                    onClick={handleDeleteSubmit}
                    disabled={deleteBankLoading}
                    className="border border-red-500 bg-white text-red-500 hover:bg-red-500 hover:text-white"
                >
                    {deleteBankLoading ? "Loading..." : "Delete"}
                </SubmitBtn>
            </div>
        </Model>
    );
};

const WarningText = tw.p`text-gray-500 text-base mb-4`;

export default DeleteBank;